export enum CNXFeatureFlags {
    HideAccessControlEmploymentTypeWhenCreatingCandidate = 'HIDE_ACCESS_CONTROL_EMPLOYMENT_TYPE_WHEN_CREATING_CANDIDATE',
    VendorClientCommunicationForApnDirectSubmittals = 'enable-vendor-client-communication-for-apn-direct-submittals',

    // Start Sergii
    DisplayVendorTagsAsChipsForSubmittals = 'display-vendor-tags-as-chips-for-submittals', // search comments by FF name and remove obsolete properties
    // End Sergii

    // Start Bruno
    AccountManagerNotificationDirectLink = 'am-notification-direct-link',
    // End Bruno

    // Start Carlos
    RunDopPipelineUi = 'RUN_DOP_PIPELINE_UI'
    // End Carlos
}
